"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const CheckBox = (0, react_1.forwardRef)((props, ref) => {
    const { checked, defaultChecked, disabled = false, name, onChange = () => null, style = {}, } = props;
    const handleCheck = (0, react_1.useCallback)((e) => {
        onChange(e);
    }, [onChange]);
    return ((0, jsx_runtime_1.jsx)("input", { ref: ref, type: "checkbox", name: name, id: name, onChange: handleCheck, checked: checked, defaultChecked: defaultChecked, disabled: disabled, style: style }));
});
exports.default = CheckBox;
